import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-button-loader',
    templateUrl: './button-loader.component.html',
    styleUrls: ['./button-loader.component.css'],
    standalone: false
})
export class ButtonLoaderComponent {
  @Input() isLoading: boolean = false;
}